import { render, staticRenderFns } from "./Screenfull.vue?vue&type=template&id=c6a6598a&scoped=true&"
import script from "./Screenfull.vue?vue&type=script&lang=js&"
export * from "./Screenfull.vue?vue&type=script&lang=js&"
import style0 from "./Screenfull.vue?vue&type=style&index=0&id=c6a6598a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a6598a",
  null
  
)

export default component.exports